import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IUser } from "./types/_user";
const api = new APIClient();

const path = "/apps";

const SettingApi = {
  getSetting(): Promise<any> {
    const url = `${path}/settings`;
    return api.get(url);
  },

  putSetting(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/settings`;
    return api.put(url, dataForm);
  },
};

export default SettingApi;
